import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
    resources: {
        de: {
            translations: {
                search: "Suchen",
                steps_in_binary: "Zwischenschritt in Binär",
                "3_integer_4_decimal_places": "3 Vorkomma- 4 Nachkommastellen",
                integer_part: "Vorkomma-Anteil",
                decimal_part: "Nachkomma-Anteil",
                bit: "Bit",
                "2": "Binär",
                "8": "Oktal",
                "10": "Dezimal",
                "16": "Hexadezimal",
                convert_x_to_y: "{{x}} zu {{y}}",
                BINARY_TO_DECIMAL: "Binär zu Dezimal",
                DECIMAL_TO_BINARY: "Dezimal zu Binär",
                BINARY_TO_DECIMAL_FLOAT: "Binär zu Dezimal",
                DECIMAL_TO_BINARY_FLOAT: "Dezimal zu Binär",
                HEXADECIMAL_TO_DECIMAL: "Hexadezimal zu Dezimal",
                HEXADECIMAL_TO_BINARY: "Hexadezimal zu Binär",
                DECIMAL_TO_HEXADECIMAL: "Dezimal zu Hexadezimal",
				BINARY_TO_HEXADECIMAL: "Binär zu Hexadezimal",
                OCTAL_TO_DECIMAL: "Oktal to Dezimal",
                DECIMAL_TO_OCTAL: "Dezimal zu Oktal",
                HEXADECIMAL_TO_BINARY_TO_OCTAL: "Hexadezimal zu Oktal mit Zwischenschritt in Binär",
                OCTAL_TO_BINARY_TO_HEXADECIMAL: "Oktal zu Hexadezimal mit Zwischenschritt in Binär",
                DECIMAL_TO_BINARY_GRADUAL_DIVISION: "Dezimal zu Binär durch Schrittweise Division",
                DECIMAL_TO_BINARY_GRADUAL_MULTIPLICATION: "Dezimal zu Binär durch Schrittweise Multiplikation",
                BINARY_ADDITION: "Binäre Addition",
                BINARY_SUBTRACTION: "Binäre Subtraktion",
                DECIMAL_TO_BINARY_SIGN_BIT_8_BIT: "Dezimal zu Binär mit Vorzeichenbit",
                BINARY_SIGN_BIT_TO_DECIMAL_8_BIT: "Binär mit Vorzeichenbit zu Dezimal",
                BINARY_ONES_COMPLEMENT_TO_DECIMAL_8_BIT: "Binäres Einerkomplement zu Dezimal",
                DECIMAL_TO_BINARY_ONES_COMPLEMENT_8_BIT: "Dezimal zu Binärem Einerkomplement",
                DECIMAL_TO_BINARY_TWOS_COMPLEMENT_8_BIT: "Dezimal zu Binärem Zweierkomplement",
                BINARY_TWOS_COMPLEMENT_TO_DECIMAL_8_BIT: "Binäres Zweierkomplement zu Dezimal",
                DECIMAL_TO_BINARY_EXCESS_127_8_BIT: "Dezimal zu Binärer Exzess-127 Darstellung",
                BINARY_TO_DECIMAL_EXCESS_127_8_BIT: "Binäre Exzess-127 Darstellung zu Dezimal",
                DECIMAL_FLOATING_POINT_TO_IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS: "Dezimal zu IEEE-754",
                IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS_TO_DECIMAL_FLOATING_POINT: "IEEE-754 zu Dezimal",
            }
        },
        en:{
            translations: {
                search: "Search",
                steps_in_binary: "Step in binary",
                "3_integer_4_decimal_places": "3 Integers and 4 Decimals",
                integer_part: "Integer part",
                decimal_part: "Decimal part",
                bit: "bit",
                "2": "Binary",
                "8": "Octal",
                "10": "Decimal",
                "16": "Hexadecimal",
                convert_x_to_y: "{{x}} to {{y}}",
                BINARY_TO_DECIMAL: "Binary to Decimal",
                DECIMAL_TO_BINARY: "Decimal to Binary",
                BINARY_TO_DECIMAL_FLOAT: "Binary to Decimal",
                DECIMAL_TO_BINARY_FLOAT: "Decimal to Binary",
                HEXADECIMAL_TO_DECIMAL: "Hexadecimal to Decimal",
                HEXADECIMAL_TO_BINARY: "Hexadecimal to Binary",
                DECIMAL_TO_HEXADECIMAL: "Decimal to Hexadecimal",
				BINARY_TO_HEXADECIMAL: "Binary to Hexadecimal",
                OCTAL_TO_DECIMAL: "Octal to Decimal",
                HEXADECIMAL_TO_BINARY_TO_OCTAL: "Hexadecimal to Octal with step in Binary",
                OCTAL_TO_BINARY_TO_HEXADECIMAL: "Octal to Hexadecimal with step in Binary",
                DECIMAL_TO_BINARY_GRADUAL_DIVISION: "Decimal to Binary by gradual division",
                DECIMAL_TO_BINARY_GRADUAL_MULTIPLICATION: "Decimal to Binary by gradual multiplication",
                BINARY_ADDITION: "Binary Addition",
                BINARY_SUBTRACTION: "Binary Subtraction",
                DECIMAL_TO_BINARY_SIGN_BIT_8_BIT: "Decimal to Binary with Sign Bit",
                BINARY_SIGN_BIT_TO_DECIMAL_8_BIT: "Binary with Sign Bit to Decimal",
                BINARY_ONES_COMPLEMENT_TO_DECIMAL_8_BIT: "Binary One's Complement to Decimal",
                DECIMAL_TO_BINARY_ONES_COMPLEMENT_8_BIT: "Decimal to Binary One's Complement",
                DECIMAL_TO_BINARY_TWOS_COMPLEMENT_8_BIT: "Decimal to Binary Two's Complement",
                BINARY_TWOS_COMPLEMENT_TO_DECIMAL_8_BIT: "Binary Two's Complement to Decimal",
                DECIMAL_TO_BINARY_EXCESS_127_8_BIT: "Decimal to Binary Excess-127 Representation",
                BINARY_TO_DECIMAL_EXCESS_127_8_BIT: "Binary Excess-127 Represntation to Decimal",
                DECIMAL_FLOATING_POINT_TO_IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS: "Decimal to IEEE-754",
                IEEE_754_32_BIT_8_INTEGERS_4_DECIMALS_TO_DECIMAL_FLOATING_POINT: "IEEE-754 to Decimal",
            }
        }
    },
    fallbackLng: "de",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
        escapeValue: false, // not needed for react!!
        formatSeparator: ","
    },

    react: {
        wait: true
    }
});

export default i18n;
